import { render } from "./backgroundMedia.vue?vue&type=template&id=4df86625&scoped=true"
import script from "./backgroundMedia.vue?vue&type=script&lang=js"
export * from "./backgroundMedia.vue?vue&type=script&lang=js"

import "./backgroundMedia.vue?vue&type=style&index=0&id=4df86625&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\siemens-ecdp-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df86625"]])

export default __exports__